/** @format */

export const TwitterSmall = ({color}) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.6405 3.35037C14.1489 3.57694 13.6239 3.73031 13.0706 3.80089C13.6408 3.44247 14.0676 2.88035 14.2722 2.2184C13.7439 2.54082 13.1581 2.7761 12.5348 2.90682C12.1237 2.44666 11.5787 2.1414 10.9846 2.03845C10.3905 1.9355 9.78046 2.04064 9.24936 2.33752C8.71825 2.6344 8.29578 3.1064 8.04757 3.6802C7.79936 4.254 7.73932 4.89746 7.87677 5.51061C6.79045 5.45581 5.72737 5.16224 4.7568 4.64904C3.78623 4.13584 2.92996 3.41453 2.24378 2.53211C1.9987 2.96771 1.87086 3.46454 1.87381 3.96995C1.87381 4.96336 2.35711 5.83652 3.08956 6.34979C2.65577 6.33545 2.23152 6.21296 1.85214 5.99251V6.02736C1.85187 6.68746 2.06995 7.32734 2.46939 7.83845C2.86883 8.34957 3.42504 8.70045 4.04367 8.83159C3.64295 8.94396 3.22324 8.96093 2.81542 8.88126C2.99105 9.44936 3.33185 9.94597 3.79029 10.3018C4.24872 10.6577 4.80193 10.855 5.37276 10.8663C4.22947 11.8053 2.77636 12.231 1.33301 12.0497C2.58607 12.8889 4.0431 13.3344 5.53108 13.3333C10.5608 13.3333 13.3081 8.97886 13.3081 5.20823C13.3081 5.08623 13.3081 4.96423 13.2998 4.84224C13.8331 4.44138 14.2997 3.93596 14.6663 3.3617L14.6397 3.35037H14.6405Z"
                fill={color}
            />
        </svg>
    );
};
